export default __webpack_public_path__ + "static/media/Dev.18285ef8.jpg";